import { useLocalStorage } from "@ugitgud/legos/hooks/useLocalStorage";
import { isAfter, subHours } from "date-fns";
import { useLayoutEffect, useState } from "react";
import { CURRENT_BANNER } from "@ugitgud/legos/components/banner/current-banner";

// Re-exported under the existing name so consumers don't need to know about the
// descriptor — see current-banner.tsx for how to swap which banner is live.
export const CURRENT_ACTIVE_BANNER = CURRENT_BANNER.ctaId;

export function useBanner(ctaId: string = CURRENT_ACTIVE_BANNER) {
  const [bannerClosed, setBannerClosed] = useState(true);
  const [bannerDismissedDate, setBannerDismissedDate] = useLocalStorage<{ dismissedDate?: string }>(`ugg-cta-${ctaId}`, {
    dismissedDate: undefined,
  });
  useLayoutEffect(() => {
    const shouldBeClosed =
      !!bannerDismissedDate.dismissedDate && isAfter(new Date(bannerDismissedDate.dismissedDate), subHours(new Date(), 1));
    setBannerClosed(shouldBeClosed);
  }, [bannerDismissedDate.dismissedDate]);

  const setBannerOpen = (value: boolean) => {
    if (!value) {
      setBannerDismissedDate({ dismissedDate: new Date().toISOString() });
    }
    setBannerClosed(!value);
  };

  return {
    open: !bannerClosed,
    dismissedDate: bannerDismissedDate.dismissedDate,
    setBannerOpen,
  };
}
